
export function HamburguerMenuImage({ color = '#fff'}) {
  return (
    <svg width="30" height="22" viewBox="0 0 30 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.66663 1H28.3333M1.66663 11H28.3333M1.66663 21H28.3333" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

